import api from "./api";

export const userService = {

  // 🔐 Auth
  login: async (data) => {
    const res = await api.post("/login", data);
    return res.data;
  },

  signup: async (data) => {
    const res = await api.post("/signup", data);
    return res.data;
  },

  logout: async () => {
    const res = await api.get("/logout");
    return res.data;
  },

  // 👤 Auth user
  getAuthUser: async () => {
    const res = await api.get("/auth-user");
    return res.data;
  },

  // 👥 Users
  getAllUsers: async () => {
    const res = await api.get("/all-users");
    return res.data.data; // 🔥 important
  },

  // ✅ Create user (use signup)
  createUser: async (data) => {
    const res = await api.post("/signup", data);
    return res.data;
  },

  // 🔥 Admin Approval
  approveUser: async (id, data) => {
    const res = await api.put(`/account-approval/${id}`, data);
    return res.data;
  }

};